import Modes from "./exercises/mode/Modes";
//import * as queryString from "query-string";

function getModesFromURL(){
    const search = window.location.search.slice(1)
    const params = new URLSearchParams(search);
    const modes = params.get("modes");

    if(!modes || modes.length === 0){
        return {};
    }
    //Modes are comma separated
    const modeValues = modes.split(",");

    //Make sure the modes exist in Modes.js
    const validatedModes = {};
    modeValues.forEach((value)=>{
        if(Modes[value]){
            validatedModes[value] = true;
        }
    });

    return validatedModes;
}

export default getModesFromURL;